// Sticky-sidebar scrollspy for ResourceElement blocks. Activates the sidebar
// link whose section is most visible in the viewport.
export default function initResourceElement() {
    if (!('IntersectionObserver' in window)) return;

    document.querySelectorAll('[data-resource-element]').forEach((root) => {
        const links = root.querySelectorAll('[data-toc-link]');
        const sections = root.querySelectorAll('[data-toc-section]');
        if (!links.length || !sections.length) return;

        const setActive = (id) => {
            links.forEach((a) => {
                a.classList.toggle('is-current', a.getAttribute('data-toc-link') === id);
            });
        };

        const ratios = new Map();

        const io = new IntersectionObserver((entries) => {
            entries.forEach((e) => {
                ratios.set(e.target.getAttribute('data-toc-section'), e.intersectionRatio);
            });
            let best = { id: null, ratio: 0 };
            ratios.forEach((ratio, id) => {
                if (ratio > best.ratio) best = { id, ratio };
            });
            if (best.id) setActive(best.id);
        }, {
            threshold: [0, 0.25, 0.5, 0.75, 1],
            rootMargin: '-30% 0px -50% 0px',
        });

        sections.forEach((s) => io.observe(s));
    });
}
